import * as Datadog from '@dreamstack/datadog'
import { useRouterLocalized, useTranslation } from '@dreamstack/i18n'
import * as React from 'react'
import { Button } from '../layout/Button'
import { BodyText, HeadingH1 } from '../layout/Texts'

type Props = {
  children: React.ReactNode
  bodyText?: string
}

export const ErrorBoundary = (props: Props) => {
  return (
    <Datadog.ErrorBoundary
      fallback={<ErrorBoundaryFallback bodyText={props.bodyText} />}
    >
      {props.children}
    </Datadog.ErrorBoundary>
  )
}

const ErrorBoundaryFallback = ({ bodyText }: { bodyText?: string }) => {
  const t = useTranslation()
  const router = useRouterLocalized()
  const finalBodyText = bodyText || t('accentro:error:whatNext')

  return (
    <div className="flex flex-col gap-y-px-16">
      <HeadingH1>{t('accentro:error:title')}</HeadingH1>
      <BodyText>{finalBodyText}</BodyText>
      <div className="flex gap-x-px-16 pt-px-16">
        <Button
          onClick={() => router.reload()}
          type="button"
          variant="contained"
          color="primary"
        >
          {t('accentro:error:reload')}
        </Button>
        <Button href="/" type="button" variant="outlined" color="secondary">
          {t('accentro:error:home')}
        </Button>
      </div>
    </div>
  )
}
